// extracted by mini-css-extract-plugin
export default {"form":"Form_form__gjyi8","group":"Form_group__VAj9t","spinner":"Form_spinner__IoH2w","spin":"Form_spin__qaLTU"};